import * as React from "react";

import V1AssetsLibrary from "@v1/components/assets/AssetsLibrary";
import Popover from "@v1/components/designSystem/popover/Popover";

const AssetLibraryPopover: React.FC<{
  anchor: React.ReactNode;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onChangeSource?: (assetUrl: string, altText: string | null) => void;
  assetTypes?: ("image" | "video")[];
}> = ({ anchor, isOpen, setIsOpen, onChangeSource, assetTypes }) => {
  return (
    <Popover.Root isOpen={isOpen} onOpenChange={setIsOpen}>
      <Popover.Content
        shouldPreventDefaultOnInteractOutside={false}
        title="Assets"
        // NOTE (Gabe 2025-03-05): For some reason this min-h-0 is necessary to
        // ensure the InfiniteSroll trigger the next page fetch.
        // NOTE (Kevin 2025-04-11): Updated width to w-96 (384px) to accommodate 3 columns
        // and height to show 3.5 rows of content
        className="flex h-[520px] min-h-0 w-96 flex-col pb-0"
        sideOffset={16}
      >
        <V1AssetsLibrary
          assetTypes={assetTypes}
          onAssetSelected={(asset) => {
            onChangeSource?.(asset.url, asset.altText); // here
            setIsOpen(false);
          }}
        />
      </Popover.Content>

      <Popover.Anchor asChild>{anchor}</Popover.Anchor>
    </Popover.Root>
  );
};

export default AssetLibraryPopover;
